export enum AppointmentStatusEnum {
	Unconfirmed = 0,
	Confirmed = 1,
	Cancelled = 2,
	Complete = 3,
	DidNotShowUp = 4,
}
export const AppointmentStatus: { name: string; value: string }[] = []

Object.keys(AppointmentStatusEnum).forEach((value: string) =>
	isNaN(+value)
		? AppointmentStatus.push({
				name: value,
				value: AppointmentStatusEnum[value as any],
		  })
		: null
)
